import React from 'react';
import Header from '../components/Header';
import Carousel from '../components/DashboardComponents/Carousel';
import './Dashboard.css';
import ManufacturingProcess from '../components/DashboardComponents/ManufacturingProcess';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';
import NewsCarousel from '../components/DashboardComponents/NewsCarousel';
import CompanyIntro from '../components/AboutUsComponents/CompanyIntro';
import WhatWeCanOffer from '../components/DashboardComponents/WhatWeCanOffer';

const Dashboard = () => {
  return (
    <div className='HomePageStyle'>
      <Header />
      <Carousel />
      <WhatWeCanOffer />
      <ManufacturingProcess />
      <NewsCarousel />
      <CompanyIntro /> 
      <CallToAction />
      <Footer />
    </div>
  );
};

export default Dashboard;